import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticStyle: { width: "100%" } }, [
    _c(
      "div",
      { staticClass: "mr-4" },
      [
        _c(
          VRow,
          [
            _c(
              VCol,
              [
                _c("filtro-cadastro", {
                  on: {
                    return: (value) => (_vm.filtros.filtroCadastro = value),
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          VRow,
          [
            _c(
              VCol,
              [
                _c("filtro-formacao", {
                  on: {
                    formacaoAcademica: (value) =>
                      (_vm.filtros.filtroFormacaoAcademica = value),
                    formacaoComplementar: (value) =>
                      (_vm.filtros.filtroFormacaoComplementar = value),
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          VRow,
          [
            _c(
              VCol,
              [
                _c("filtro-atuacao-profissional", {
                  on: {
                    return: (value) =>
                      (_vm.filtros.filtroAtuacaoProfissional = value),
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          VRow,
          [
            _c(
              VCol,
              [
                _c("filtro-atividade-interesse", {
                  on: {
                    return: (value) =>
                      (_vm.filtros.filtroAtividadeInteresse = value),
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          VRow,
          [
            _c(
              VCol,
              [
                _c("filtro-preferencia-trabalho", {
                  on: {
                    return: (value) =>
                      (_vm.filtros.filtroPreferenciaTrabalho = value),
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "ml-2" },
          [
            _vm.resumos.length > 0
              ? _c(
                  VRow,
                  { attrs: { dense: "" } },
                  [
                    _c(
                      VCol,
                      [
                        _c("resumo-filtro-busca", {
                          attrs: { value: _vm.resumos },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              VRow,
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.pesuisaInicial,
                    expression: "pesuisaInicial",
                  },
                ],
              },
              [
                _c(
                  VCol,
                  [
                    _c("resultado-filtro-busca", {
                      attrs: { perfis: _vm.perfis },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          VRow,
          { staticClass: "justify-end mx-1 my-4", attrs: { dense: "" } },
          [
            _c(
              VTooltip,
              {
                attrs: { top: "" },
                scopedSlots: _vm._u([
                  {
                    key: "activator",
                    fn: function ({ on: onTooltip }) {
                      return [
                        _c(
                          VBtn,
                          _vm._g(
                            {
                              attrs: { color: "primary" },
                              on: { click: _vm.pesquisar },
                            },
                            { ...onTooltip }
                          ),
                          [_vm._v(" Pesquisar ")]
                        ),
                      ]
                    },
                  },
                ]),
              },
              [_c("span", [_vm._v("Clique para pesquisar")])]
            ),
            _vm.perfis.length > 0
              ? _c(
                  VTooltip,
                  {
                    attrs: { "max-width": "400", top: "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "activator",
                          fn: function ({ on }) {
                            return [
                              _c(
                                VBtn,
                                _vm._g(
                                  {
                                    staticClass: "ml-2",
                                    attrs: { color: "success" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.getRelatorio()
                                      },
                                    },
                                  },
                                  on
                                ),
                                [
                                  _c(VIcon, [_vm._v("get_app")]),
                                  _vm._v(" BAIXAR PDF "),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      77993758
                    ),
                  },
                  [
                    _c("span", [
                      _vm._v(
                        "Clique para baixar o relatório dos dados em formato PDF."
                      ),
                    ]),
                  ]
                )
              : _vm._e(),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }